import View     from 'scripts/poppet/view';
import template from 'templates/forecastTodayView.jst.html';

const ForecastTodayView = View.extend( {
	template: template,
} );

export default ForecastTodayView;